import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { EIPRoleEnum } from "src/app/shared/generated/enum/e-i-p-role-enum";

/**
 * Gates routes that should only be reachable by EIP administrators (and read-only
 * admins). Mirrors the `showManageMenu()` check in EipLayoutComponent so the UI
 * affordance and the URL-level check stay aligned. Unauthorized access is
 * redirected to the EIP area root.
 */
@Injectable({ providedIn: "root" })
export class EipAdminAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const isEipAdmin = user?.EIPRoleID === EIPRoleEnum.Admin || user?.EIPRoleID === EIPRoleEnum.ReadOnlyAdmin;
                if (!isEipAdmin) {
                    this.router.navigate(["/eip"]);
                    return false;
                }
                return true;
            })
        );
    }
}
